module.exports = __webpack_public_path__ + "static/media/CharmingCharlie.png.png.43edc2ef.webp";